import { Message } from "../Message";

export const messages = {
    VLD_LOOKUP_CODE: new Message<[lookupName: string, lookupCode: string]>("VLD_LOOKUP_CODE", "{0} code '{1}' does not exist")
};
